import { GridColumns } from 'shared/types';
import { AccountNumberParams } from 'pages/managePricing/managePricingResolver';
import { useParams } from 'react-router-dom';
import { ProductFilterEnum } from 'shared/constants';
import { createTableDataContext } from 'shared/providers/provideTableData';
import { TAddProductsData } from 'types/backend';
import { ProductsResolver } from './ProductsResolver';

interface PrivateProductsResolverProps {
    columnConfig: GridColumns<TAddProductsData>;
}

export const privateProductsContext = createTableDataContext<TAddProductsData>();

export function PrivateProductsResolver({columnConfig}: PrivateProductsResolverProps) {
    const {accountNumber} = useParams<AccountNumberParams>();
    return (
        <ProductsResolver
            columnConfig={columnConfig}
            productsContext={privateProductsContext}
            productTabSelected={ProductFilterEnum.PRIVATE}
            name='PrivateProduct'
            alternateQueryPath={`subset/${accountNumber}`}
            title='Available Private Products'
        />
    );
}
